import { useState } from 'react'

import Modal from '@components/Modal'
import Button from '@components/Button'

import { withTranslate } from '@i18n/utils'
import { AddCreditCard } from 'credit-cards'

const AddCreditCardModalComponent = () => {
    const [open, setOpen] = useState(false)

    const closeModal = () => {
        setOpen(false)
    }

    return (
        <>
            <Button size="small" btnStyle="link" iconLeft="plus-round" onClick={() => setOpen(true)}>
                <T>dashboard.label.add.credit.card</T>
            </Button>
            {open && (
                <Modal size="large" onClose={closeModal} header={<T>dashboard.label.add.credit.card</T>}>
                    <AddCreditCard successCallback={closeModal} />
                </Modal>
            )}
        </>
    )
}

const AddCreditCardModal = withTranslate(AddCreditCardModalComponent)

export default AddCreditCardModal
